import React from 'react';
import { WavyDivider } from '../WavyDivider';

/**
 * BLOCK PART: section divider
 * ACF: `divider_from` + `divider_to` colour fields on each flexible-content row.
 *
 * Wraps WavyDivider so pages express transitions as "from colour → to colour"
 * instead of repeating the same absolutely-positioned markup everywhere.
 */

interface SectionDividerProps {
  /** Background of the section above. */
  from: string;
  /** Background of the section below (the wave's fill). */
  to: string;
  className?: string;
}
export function SectionDivider({
  from,
  to,
  className = ''
}: SectionDividerProps) {
  return <div className={`pointer-events-none relative ${className}`} style={{
    backgroundColor: from
  }} data-id="element-174" data-mp="27whwgok4sh7u">
      <WavyDivider fill={to} data-id="element-175" data-mp="2bxjwv8psazbe" />
    </div>;
}

/** Brand palette tokens, mirrored from tailwind.config.js for divider fills. */
export const SURFACE = {
  cream: '#F8F2E4',
  creamDeep: '#EFE6D5',
  sage: '#E8EFE7',
  rose: '#F5EBEB',
  charcoal: '#3A3A38',
  white: '#FFFFFF'
} as const;